/*
 * @Description: 权限先关接口
 */

import { RootObject } from '@/model/rootObject'
import https from '@/utils/https'
import { ContentType, Method } from 'axios-mapper'
import { RolePageModel, RoleModel, RolePageParamModel, RoleCreateModel, RolePermissionViewModel, RolePermissionCreateModel } from '@/model/roleModel'

export const getAllRoleNames = () => {
  return https().request<RootObject<string[]>>('/base/user/role/all', Method.GET, undefined, ContentType.json)
}

export const getRoleListForPage = (params: RolePageParamModel) => {
  return https().request<RootObject<RolePageModel>>('/base/user/role/list', Method.POST, params, ContentType.json)
}

export const addRole = (params: RoleCreateModel) => {
  return https().request<RootObject<number>>('/base/user/role/add', Method.POST, params, ContentType.json)
}

export const editRole = (params: RoleModel) => {
  return https().request<RootObject<number>>('/base/user/role/edit', Method.POST, params, ContentType.json)
}

export const deleteRole = (roleId: number) => {
  return https().request<RootObject<number>>('/base/user/role/delete/' + roleId, Method.POST, undefined, ContentType.json)
}

export const getRolePermission = (roleId: number) => {
  return https().request<RootObject<RolePermissionViewModel[]>>('/base/user/role/permission/' + roleId, Method.GET, undefined, ContentType.json)
}

export const roleAuthorization = (roleId: number, params: RolePermissionCreateModel) => {
  return https().request<RootObject<number>>('/base/user/role/authorization/' + roleId, Method.POST, params, ContentType.json)
}
